/**
 *
 * @author [(Shojib, mahmud.hossain@mlb.com)]
 * @module BaseLinker
 *
 */

'use strict';

import BamArgValidator from 'bam-arg-validator';

/**
 * @class BaseLinker
 */
class BaseLinker {

    /**
     * @method constructor
     * @param options (siteId, teamId, leagueId, ymdDate, calEventId, gameId, videoId)
     */
    constructor(windowOrReq, options = {}) {


        let metaTeamId;
        let metaLeagueId;
        let metaAppView;
        let metaLocale;
        let metaSlug;

        if (windowOrReq.navigator) {
            this._deviceType = windowOrReq.getStartupDeviceTypeString ?
                windowOrReq.getStartupDeviceTypeString() : 'desktop';
            this._metaTags = windowOrReq.document.getElementsByTagName('meta');

            metaTeamId = this.getMetaTagContent(this._metaTags, 'team-id');
            metaLeagueId = this.getMetaTagContent(this._metaTags, 'league-id');
            metaAppView = this.getMetaTagContent(this._metaTags, 'app-view');
            metaLocale = this.getMetaTagContent(this._metaTags, 'locale');
            metaSlug = this.getMetaTagContent(this._metaTags, 'club');

        } else if (windowOrReq.locals) {

            const {
                team,
                league
            } = windowOrReq.locals.globalData || {};

            const {
                appViews,
                locale,
                club
            } = windowOrReq.locals.responseConfig || {};

            this._deviceType = options.deviceType || 'desktop';
            metaTeamId = team && team.data && team.data.team.id;
            metaLeagueId = league && league.data && league.data.league.id;
            metaAppView = appViews || '';
            metaLocale = locale || 'en';
            metaSlug = (!club) ? '' : club;
        }

        let siteId;

        if (metaTeamId) {
            siteId = `t${metaTeamId}`;
        } else if (metaLeagueId) {
            siteId = `l${metaLeagueId}`;
        } else {
            siteId = null;
        }

        if (options.langCodeOverride) {
            options.locale = options.langCodeOverride;
        }

        if (options.teamSlugs || windowOrReq.teamSlugs) {
            options.teamSlugs = options.teamSlugs || windowOrReq.teamSlugs || null;
        }

        this._siteId = options.siteId || siteId;
        this._teamId = options.teamId || metaTeamId;
        this._slug = options.slug || metaSlug || '';
        this._leagueId = options.leagueId || metaLeagueId;
        this._appView = options.appView || metaAppView;
        this._langCode = options.locale || metaLocale;

        this._ymdDate = options.ymdDate || null;
        this._calEventId = options.calEventId || null;
        this._gameId = options.gameId || null;
        this._videoId = options.videoId || null;
        this._teamSlugs = options.teamSlugs || null;
        this._sportCodeMap = {
            11: 'aaa',
            12: 'aax',
            13: 'afa',
            14: 'afx',
            15: 'asx',
            16: 'rok',
            17: 'win'
        };
    }

    set siteId(sId) {
        this._siteId = sId;
    }

    get siteId() {
        return this._siteId;
    }

    set leagueId(id) {
        this._leagueId = id;
    }

    get leagueId() {
        return this._leagueId;
    }

    set ymdDate(ymd) {
        this._ymdDate = ymd;
    }

    get ymdDate() {
        return this._ymdDate;
    }

    set calEventId(calEvtId) {
        this._calEventId = calEvtId;
    }

    get calEventId() {
        return this._calEventId;
    }

    set gameId(gId) {
        this._gameId = gId;
    }

    get gameId() {
        return this._gameId;
    }

    set videoId(vidId) {
        this._videoId = vidId;
    }

    get videoId() {
        return this._videoId;
    }

    set metaTags(mTags) {
        this._metaTags = mTags;
    }

    get metaTags() {
        return this._metaTags;
    }

    get sportCodeMap() {
        return this._sportCodeMap;
    }

    get teamSlugs() {
        return this._teamSlugs;
    }

    /**
     * @method getMetaTagContent
     * @param metaTagEls, key
     */
    getMetaTagContent(metaTagEls, key) {
        const metaTagKeyAttrNames = ['name', 'property', 'http-equiv'];

        for (var k = 0, kln = metaTagKeyAttrNames.length; k < kln; k++) {
            for (var i = 0, mln = metaTagEls.length; i < mln; i++) {
                if (metaTagEls[i].getAttribute(metaTagKeyAttrNames[k]) === key) {
                    return metaTagEls[i].getAttribute('content');
                }
            }
        }
        return null;
    }

    /**
     * @method buildLink
     * @param linker, urlSegment, keepTeam
     */
    buildLink(linker, urlSegment, keepTeam) {
        BamArgValidator.validateArgs(arguments, ['linker', 'urlSegment', 'keepTeam'],
            ['object', 'string', 'boolean'], [true, true, false]);

        const url = (linker._appView === 'web' ? '' : '/' + linker._appView)
            + (linker._langCode === 'en' ? '' : '/' + linker._langCode)
            + (keepTeam ? (linker._slug ? '/' + linker._slug : '') : '')
            + urlSegment;
        return url;
    }

    /**
     * @method getLink
     * @param urlSegment, keepTeam
     */
    getLink(urlSegment, keepTeam) {
        BamArgValidator.validateArgs(arguments, ['urlSegment', 'keepTeam'], ['string', 'boolean'], [true, false]);
        const keepTeamPathElement = (keepTeam === undefined ? true : keepTeam);

        let segment = '' + urlSegment;
        if (segment.charAt(0) !== '/') {
            segment = '/' + segment;
        }

        return this.buildLink(this, segment, keepTeamPathElement);
    }

}

export default BaseLinker;

